/* eslint-disable */

YP.FileUpload = function FileUpload() {
    return {
        init: function() {
            if($( '.js-file-upload' ).length > 0) {
                $( '.js-file-upload' ).each( function()
                {
                    var $input   = $( this ),
                        $label   = $input.next( '.c-form-label' ),
                        labelVal = $label.html();

                    $input.on( 'change', function( e )
                    {
                        var fileName = '';
                        console.log(this.files);
                        if(this.files && this.files.length > 1 ) {
                            fileName = ( this.getAttribute( 'data-multiple-caption' ) || '' ).replace( '{count}', this.files.length );
                        } else if( e.target.value ) {
                            fileName = e.target.value.split( '\\' ).pop();
                        }

                        if(this.files.length == 1 && $('.js-fileupload__preview').length) {
                            file = this.files[0];
                            if([
                                'image/jpeg',
                                'image/pjpeg',
                                'image/png',
                                'image/x-png'
                            ].includes(file.type)) {
                                console.log("ok");
                                var reader = new FileReader();
                                reader.onload = function (e) {
                                    $('.js-fileupload__preview').attr('src', e.target.result).show();
                                };
                                reader.readAsDataURL(file);
                            } else {
                                $('.js-fileupload__preview').attr('src','').hide();
                            }
                        }

                        if(fileName) {
                            $label.find( '.js-fileupload__name' ).html( fileName );
                        } else {
                            $label.html( labelVal );
                        }
                    });

                    // Firefox bug fix
                    $input
                    .on( 'focus', function(){ $input.addClass( 'has-focus' ); })
                    .on( 'blur', function(){ $input.removeClass( 'has-focus' ); });
                });
            }
        }
    }
};

window.addEventListener("load", function(){
    YP.FileUpload().init();
});
